import React, { Component } from 'react';
import Rater from 'react-rater';
import { Col } from 'reactstrap';

type RatingsProps = {
  title: string,
  onRate: (rating: number, title: string) => void,
};

export default class Ratings extends Component<RatingsProps> {
  state = { rating: 0 };

  handleRate = ({ type, rating }) => {
    const { onRate, title } = this.props;

    const userClickedOnRatings = type === 'click';

    if (userClickedOnRatings) {
      const modifiedTitle = this.splitLowerCaseAndUnderScoreTitle(title);
      this.setState({ rating });
      onRate(rating, modifiedTitle);
    }
  };

  /**
   * @param  {String} title Eg: Organisational Skills
   * @return {String} title Eg: organisational_skiils
   */

  splitLowerCaseAndUnderScoreTitle = (title: string) =>
    //NOTE: There is "Value for Money" title in lodge details but the api needs just "value" as key.
    title === 'Value for Money'
      ? 'value'
      : title
          .split(' ')
          .map(x => x.toLowerCase())
          .join('_');

  render() {
    const { title } = this.props;
    const { rating } = this.state;

    return (
      <Col md="6" className="my-2">
        <p className="rate-q">{title}</p>
        <Rater total={10} rating={rating} onRate={this.handleRate} />
        <span className="ml-2">{rating}/10</span>
      </Col>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ReviewsRatings/Ratings.jsx